import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvTaskEditor.html?raw';
import "../EvBookingEditorTypes";
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";

class EvTaskEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;
    inputTaskDescript: MdsLax<InstanceType<typeof SearchSelect>>;

    _onChangeTaskDescriptInputData(): void {
        let value = this.inputTaskDescript.getValue();
 
        if (value != null) {
            this.emit("added", this.inputTaskDescript.getValue(true), [EvBookingEditor_ListNames.evTasks]);
            this.inputTaskDescript.setValue(null);
        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.inputTaskDescript.loadListValues();
        this.UiModder.domStyle.set(this.inputTaskDescript.domNode, "width", "100%");

        this.domNode.addEventListener('click', function (evt) {

            evt.stopPropagation();

        });

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        
    }
}

export default mdsWidget(EvTaskEditor);